import React from 'react';
import { ISvgProps } from '../svg.types';

export const SvgProfileCardNeutral = (props: ISvgProps) => (
  <svg
    width={142}
    height={126}
    viewBox="0 0 142 126"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <defs>
      <filter
        x="-8.9%"
        y="-8.1%"
        width="117.8%"
        height="118%"
        filterUnits="objectBoundingBox"
        id="a"
      >
        <feOffset dy={1} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation={3}
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0967787591 0"
          in="shadowBlurOuter1"
        />
      </filter>
      <filter
        x="-8.9%"
        y="-8.1%"
        width="117.8%"
        height="118.2%"
        filterUnits="objectBoundingBox"
        id="c"
      >
        <feOffset dy={1} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation={3}
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0967787591 0"
          in="shadowBlurOuter1"
        />
      </filter>
      <filter
        x="-9.1%"
        y="-8.6%"
        width="118.3%"
        height="119.2%"
        filterUnits="objectBoundingBox"
        id="e"
      >
        <feOffset dy={1} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation={3}
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0967787591 0"
          in="shadowBlurOuter1"
        />
      </filter>
      <path
        d="M8.46 3.384L95.206.04a8.8 8.8 0 019.134 8.515l2.657 83.99a8.8 8.8 0 01-8.457 9.071l-86.746 3.344a8.8 8.8 0 01-9.134-8.515L.003 12.455A8.8 8.8 0 018.46 3.384z"
        id="b"
      />
      <path
        d="M34.789 7.039l86.745 3.312a8.8 8.8 0 018.46 9.075l-2.651 83.022a8.8 8.8 0 01-9.132 8.513l-86.745-3.312a8.8 8.8 0 01-8.46-9.075l2.651-83.022a8.8 8.8 0 019.132-8.513z"
        id="d"
      />
      <rect id="f" x={11} y={15} width={104} height={99} rx={8.8} />
    </defs>
    <g transform="translate(6 5)" fill="none" fillRule="evenodd">
      <use fill="#000" filter="url(#a)" xlinkHref="#b" />
      <use fill="#FFF" xlinkHref="#b" />
      <use fill="#000" filter="url(#c)" xlinkHref="#d" />
      <use fill="#FFF" xlinkHref="#d" />
      <use fill="#000" filter="url(#e)" xlinkHref="#f" />
      <use fill="#FFF" xlinkHref="#f" />
      <g transform="translate(45 35)">
        <circle fill="#EAEAEA" cx={19.409} cy={19.409} r={19.409} />
        <ellipse fill="#FAC9B8" cx={19.409} cy={14.149} rx={4.898} ry={9.07} />
        <g fillRule="nonzero">
          <path
            d="M14.512 9.07h.725c0 4.905 1.339 7.256 3.976 7.256 2.109 0 3.35-1.25 3.645-3.672l.72.088c-.338 2.768-1.868 4.31-4.365 4.31-3.147 0-4.701-2.73-4.701-7.982z"
            fill="#545454"
          />
          <path
            d="M14.659 9.764a.363.363 0 01-.295-.663l3.478-1.546.175.154c.65.574 1.57 1.034 2.762 1.375 1.876.536 3.025 2.834 3.525 6.834a.363.363 0 01-.72.09c-.467-3.74-1.495-5.795-3.005-6.227-1.187-.339-2.141-.796-2.862-1.376l-3.058 1.36zM17.478 16.656l.723.065a8.558 8.558 0 000 1.382l-.723.073a9.256 9.256 0 010-1.52zm2.443 1.453l.361.03.363-.007-.029-1.45-.724.04c.043.465.05 1.126.029 1.387z"
            fill="#545454"
          />
          <path
            d="M20.643 18.17l-.724-.023-.028-1.452.724-.04c.047.506.054 1.21.028 1.515z"
            fill="#545454"
          />
          <path
            d="M17.595 17.414h.545v.726c-3.154.375-5.816 2.232-5.816 4.353h-.715c0-2.553 2.512-4.665 5.986-5.079zm8.889 5.079h-.726c0-2.066-2.217-3.89-5.311-4.327l.101-.718c3.414.481 5.936 2.556 5.936 5.045z"
            fill="#B6BBB9"
          />
          <path
            d="M12.283 22.85l-.622.375c-1.24-2.056-1.866-3.683-1.866-4.904 0-.774.24-1.153.814-1.566.023-.017.11-.08.13-.093l.124-.091c.436-.335.658-.722.748-1.554.126-1.154.009-1.798-.43-3.08-.298-.874-.413-1.3-.477-1.923-.11-1.067.952-2.745 2.568-4.169 1.798-1.584 3.945-2.58 5.956-2.58 3.786 0 6.098 1.645 7.757 4.726 1.257 2.335 1.547 3.497 1.309 5.122-.11.754-.294 1.158-.702 1.732l-.142.2a3.23 3.23 0 00-.442.855c-.091.264-.06.43.098.67.068.101.4.52.457.597.434.592.678 1.192.734 2.037.102 1.533-.537 3.13-1.895 4.789l-.562-.46c1.251-1.527.75-6.43.662-6.562-.277-.417-.35-.814-.18-1.308.137-.397.295-.689.532-1.031l.147-.207c.346-.487-.59 8.514-.499 7.887.065-.447-.495-1.765-1.832-3.108-.956-.96-3.092-1.414-3.99-1.79-.34-.142.16-.72 0-.659-.751.288 3.182-2.784 2.72-3.642-1.541-2.862-2.855-4.769-6.349-4.769-1.812 0-.574.285-2.358 1.596-.544.4 1.554 5.192 1.633 5.96.021.21 1.742.774 1.27.855-.297.051.866.573.18.659-1.995.25-2.72.726-3.627 1.27-.396.237-1.148.803-1.649 1.393-.584.69-.839 1.596-.839 1.872 0 1.058-.556-1.052.622.9z"
            fill="#545454"
          />
          <path
            d="M12.283 22.85l-.622.375c-1.24-2.056-1.866-3.683-1.866-4.904 0-.774.24-1.153.814-1.566.023-.017.11-.08.13-.093l.124-.091c.436-.335.658-.722.748-1.554.126-1.154.009-1.798-.43-3.08-.298-.874-.413-1.3-.477-1.923-.11-1.067.952-2.745 2.568-4.169 1.798-1.584 3.945-2.58 5.956-2.58 3.786 0 6.098 1.645 7.757 4.726 1.257 2.335 1.547 3.497 1.309 5.122-.11.754-.294 1.158-.702 1.732l-.142.2a3.23 3.23 0 00-.442.855c-.091.264-.06.43.098.67.068.101.4.52.457.597.434.592.678 1.192.734 2.037.102 1.533-.537 3.13-1.895 4.789l-.562-.46c1.251-1.527 1.821-2.953 1.733-4.281-.047-.697-.238-1.169-.595-1.655-.041-.056-.388-.494-.476-.626-.277-.417-.35-.814-.18-1.308.137-.397.295-.689.532-1.031l.147-.207c.346-.487.483-.79.575-1.417.212-1.45-.04-2.463-1.23-4.673-1.542-2.863-3.624-4.344-7.118-4.344-1.812 0-3.8.922-5.477 2.399-1.455 1.282-2.404 2.782-2.325 3.55.057.554.16.937.438 1.748.474 1.388.608 2.126.469 3.407-.112 1.031-.437 1.598-1.029 2.052a5.421 5.421 0 01-.142.104c-.02.016-.108.078-.13.093-.4.288-.511.464-.511.977 0 1.059.584 2.576 1.762 4.529z"
            fill="#545454"
          />
          <path fill="#B6BBB9" d="M11.61 21.767h.725v11.247h-.726z" />
          <path
            d="M26.484 22.13v10.884c0 .601-.488 1.088-1.089 1.088H12.711a1.1 1.1 0 01-1.102-1.088c0-.23 4.958-3.857 14.875-10.884z"
            fill="#B6BBB9"
          />
          <path
            d="M14.731 18.665l.65-.325c.785 1.572 1.99 2.34 3.666 2.34 1.674 0 2.88-.768 3.666-2.34l2.501 1.795c-.315.63 1.643 1.542.907 3.265-1.385 3.243-5.799 7.8-7.074 7.8-.84 0-5.04 3.976-6.712 1.27-.946-1.532-.057-9.537-.363-10.884-.413-1.817 3.057-2.327 2.76-2.921z"
            fill="#B6BBB9"
          />
        </g>
        <path
          d="M16.507 7.437c1.15.935 1.875 1.479 2.177 1.633.998.509 2.331.95 2.72 1.27.567.465 1.05 1.19 1.452 2.176l.544 1.089c.114-.844.174-1.57.181-2.177.027-2.258-3.313-2.802-3.809-3.265-.696-.651-1.784-.893-3.265-.726z"
          fill="#373436"
        />
        <path
          d="M18.14 8.012c-.59.557-.962.88-1.117.972-.512.304-1.195.566-1.395.757-.29.277-.539.71-.744 1.297l-.28.648c-.058-.502-.089-.935-.092-1.297-.014-1.345 1.7-1.669 1.953-1.945.357-.388.915-.532 1.675-.432z"
          fill="#373436"
        />
      </g>
      <rect fill="#EAEAEA" x={48} y={80} width={35} height={4} rx={2} />
      <rect fill="#EAEAEA" x={41} y={87} width={49} height={4} rx={2} />
    </g>
  </svg>
);
